import { InfoIcon } from "@src/components/elements/assets";
import React, { ReactElement } from "react";
import styled from "styled-components/macro";
import { Tooltip } from "@src/components/elements";

const StyledRoot = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    cursor: pointer;
  }

  span {
    display: inline-flex;
    align-items: center;
  }
`;

export const InfoMenu: React.FC<{
  title: string | ReactElement;
  alignTooltip?: "top" | "right";
}> = ({ title, alignTooltip }) => {
  return (
    <StyledRoot>
      <Tooltip title={title} showWithoutOverflow={true} align={alignTooltip}>
        <span>
          <InfoIcon className="icon" />
        </span>
      </Tooltip>
    </StyledRoot>
  );
};
